import { AppState } from "app/shared/store/root.reducer";
import { createSelector } from "reselect";

const getHasKey = (state: AppState) => state.account.hasKey;

const getUserProfile = (state: AppState) => state.account.USERPROFILE;
const getContactId = (state: AppState) => state.account.hashContactId;

const getListAccount = (state: AppState) => state.account.LIST_ACCOUNT_PROFILE;

const getLimitRemain = (state: AppState) => state.account.LIMIT_REMAIN;

const getAccountProfile = (state: AppState) => state.account.ACCOUNTPROFILE;

const getStatusListAccountLogin = (state: AppState) => state.account.statusListAccountLogin;
const getStatusListAccount = (state: AppState) => state.account.statusListAccount;

const getListAccountCustomer = (state: AppState) => state.account.LIST_ACCOUNT_CUSTOMER;
const getSignature = (state: AppState) => state.account.signature;

export const getHasKeySelector = createSelector(getHasKey, (str) => str);
export const getUserProfileSelector = createSelector(getUserProfile, (account) => account);
export const getContactIdSelector = createSelector(getContactId, (id) => id);
export const getListAccountSelector = createSelector(getListAccount, (accounts) => accounts);
export const getLimitRemainSelector = createSelector(getLimitRemain, (limit) => limit);
export const getAccountProfileSelector = createSelector(getAccountProfile, (account) => account);
export const getListAccountCustomerSelector = createSelector(getListAccountCustomer, (account) => account);
export const getSignatureSelector = createSelector(getSignature, (signature) => signature);

export const getStatusListAccountLoginSelector = createSelector(getStatusListAccountLogin, (status) => status);
export const getStatusListAccountSelector = createSelector(getStatusListAccount, (status) => status);
